!function(e){var n=window.Cookies,t=window.Cookies=function(){function e(){for(var e=0,n={};e<arguments.length;e++){var t=arguments[e];for(var o in t)n[o]=t[o]}return n}function n(e){return e.replace(/(%[0-9A-Z]{2})+/g,decodeURIComponent)}return function t(o){function r(){}function i(n,t,i){if("undefined"!=typeof document){"number"==typeof(i=e({path:"/"},r.defaults,i)).expires&&(i.expires=new Date(1*new Date+864e5*i.expires)),i.expires=i.expires?i.expires.toUTCString():"";try{var c=JSON.stringify(t);/^[\{\[]/.test(c)&&(t=c)}catch(e){}t=o.write?o.write(t,n):encodeURIComponent(String(t)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g,decodeURIComponent),n=encodeURIComponent(String(n)).replace(/%(23|24|26|2B|5E|60|7C)/g,decodeURIComponent).replace(/[\(\)]/g,escape);var u="";for(var f in i)i[f]&&(u+="; "+f,!0!==i[f]&&"string"==typeof i[f]&&(u+="="+i[f].split(";")[0]));return document.cookie=n+"="+t+u}}function c(e,t){if("undefined"!=typeof document){for(var r={},i=document.cookie?document.cookie.split("; "):[],c=0;c<i.length;c++){var u=i[c].split("="),f=u.slice(1).join("=");t||'"'!==f.charAt(0)||(f=f.slice(1,-1));try{var a=n(u[0]);if(f=(o.read||o)(f,a)||n(f),t)try{f=JSON.parse(f)}catch(e){}if(r[a]=f,e===a)break}catch(e){}}return e?r[e]:r}}r.set=i;r.get=function(e){return c(e,!1)};r.getJSON=function(e){return c(e,!0)};r.remove=function(n,t){i(n,"",e(t,{expires:-1}))};r.defaults={};r.withConverter=t;return r}(function(){})}();t.noConflict=function(){return window.Cookies=n,t}}();
var csCookies = Cookies.noConflict();

document.body.classList.add('smc-cookies--rejected');
var cookieScriptToggle = document.querySelectorAll('.kg-embed-card');

var
cookieScriptWindow = window.document,
cookieScripts = document.getElementsByTagName("script"),
cookieScriptSrc = cookieScripts[cookieScripts.length - 1].src,
cookieQuery = null,
cookieScriptSource = "cookie-script.com",
cookieScriptDomain = "",
cookieScriptReadMore = "/datenschutz/",
cookieId = "b78d56216959634e693e1417efc5512a",
cookieScriptDebug = 0,
cookieScriptShowBadge=true,
cookieScriptBadgeText = "Cookie Einstellungen",
cookieScriptCurrentUrl = window.location.href,
cookieScriptTitle = "",
cookieScriptDesc = "Diese Webseite verwendet <strong>ausschließlich</strong> technisch notwendige Cookies. Lediglich für die Anzeige von externen Inhalten können zusätzliche Cookies erforderlich sein. Diese werden jedoch erst <strong>nach</strong> Ihrer Zustimmung geladen. ",
cookieScriptSave = "Speichern & schließen",
cookieScriptAcceptAll = "Akzeptieren",
cookieScriptMore = "Zur Datenschutzerklärung",
cookieScriptReject = "Ablehnen",
cookieScriptIsCategories = "",cookieScriptLoadJavaScript = function (d, b) {
var c = document.getElementsByTagName("head")[0],
a = document.createElement("script");
a.type = "text/javascript", a.src = d, b != undefined && (a.onload = a.onreadystatechange = function () {
(!a.readyState || /loaded|complete/.test(a.readyState)) && (a.onload = a.onreadystatechange = null, c && a.parentNode && c.removeChild(a), a = undefined, b())
}), c.insertBefore(a, c.firstChild)
},

          InjectCookieScript = function () {

if (window.location.protocol == "https:") cookieScriptStatsDomain = "";
else                                      cookieScriptStatsDomain = "chs03.";
cookieScriptCreateCookie = function (n, t, i) {
	if (window.location.protocol == "https:")
                var cookieScriptSecureCookie = ";secure";
              else
                var cookieScriptSecureCookie = "";
              var u = "",
                r, f;
              i && (r = new Date, r.setTime(r.getTime() + i * 864e5), u = "; expires=" + r.toGMTString()), f = "", cookieScriptDomain != "" && (f = "; domain=" + cookieScriptDomain), document.cookie = n + "=" + t + u + f + "; path=/" + cookieScriptSecureCookie;
            },

              cookieScriptReadCookie = function (n) {
				  for (var r = n + "=", u = document.cookie.split(";"), t, i = 0; i < u.length; i++) {
					  for (t = u[i]; t.charAt(0) == " ";) t = t.substring(1, t.length);
					  if (t.indexOf(r) == 0) return t.substring(r.length, t.length)
                }
                return null
              };            cookieQuery(function () {
              cookieQuery("#cookiescript_injected", cookieScriptWindow).remove();
				  cookieQuery("#cookiescript_badge", cookieScriptWindow).remove();
				  cookieQuery("style[data-type=cookiescriptstyles]", cookieScriptWindow).remove();

              cookieScriptAddBox = function () {
              	cookieQuery("body", cookieScriptWindow).append('<div id="cookiescript_injected"><div id="cookiescript_leftpart"><div id="cookiescript_description">' + cookieScriptDesc +  ' <a id="cookiescript_readmore" href="' + cookieScriptReadMore + '">' + cookieScriptMore + '</a></div></div><div id="cookiescript_rightpart"><div id="cookiescript_buttons"><div id="cookiescript_accept">' + cookieScriptAcceptAll + '</div><div id="cookiescript_reject">' + cookieScriptReject + '</div></div></div><div id="cookiescript_close">×</div><div id="cookiescript_pixel"></div></div>');

				cookieQuery("#cookiescript_injected", cookieScriptWindow).fadeIn(1000);


				cookieQuery("#cookiescript_save", cookieScriptWindow).click(function () {
					cookieScriptRejectFunction();
					if(typeof cookieScriptTrack !== 'undefined') {
						var checkedCategories=[];
						cookieQuery('#cookiescript_injected input[data-cookiescript="checkbox-input"]').each(function() {
							if(cookieQuery(this).is(':checked') && cookieQuery(this).val() !== 'strict') {
								if(!checkedCategories.includes(cookieQuery(this).val())) {
									checkedCategories.push(cookieQuery(this).val());
								}
							}
						});
						cookieScriptTrack('accept',checkedCategories.join(','));	//TODO  -add categories
					}
				});

				cookieQuery("#cookiescript_reject", cookieScriptWindow).click(function () {
					if(typeof cookieScriptTrack !== 'undefined') {
						cookieScriptTrack('reject','');
					}
					cookieScriptRejectFunction()				});

				cookieQuery("#cookiescript_close").click(function () {
					cookieScriptCloseFunction();
					if(typeof cookieScriptTrack !== 'undefined') {
							cookieScriptTrack('close','');
					};
				});

				cookieQuery("#cookiescript_accept").click(function () {
				cookieScriptAcceptFunction();
					if(typeof cookieScriptTrack !== 'undefined') {
					cookieScriptTrack("accept","");
					}				});
	            cookieQuery("#cookiescript_readmore", cookieScriptWindow).click(function () {
	            	if(typeof cookieScriptTrack !== 'undefined') {
						cookieScriptTrack('readmore','');
					}
              	});
              cookieScriptLoadValueCategories();
            }

	cookieScriptCurrentValue=cookieScriptReadVar("action");
	if(cookieScriptCurrentValue == "accept") {
		cookieScriptToggleAcceptedFunction();
	}
	if(cookieScriptCurrentValue == "reject") {
		cookieScriptToggleRejectedFunction();
	}
	if(cookieScriptCurrentValue == "accept")
		cookieScriptAllowJS();
	if(cookieScriptCurrentValue == "accept" || cookieScriptCurrentValue == "reject")
	{
		cookieScriptShowBadgeFunction();

		return false;
	}            cookieScriptAddBox();
             // cookieScriptAltIframe();
			            });
		function cookieScriptAltIframe() {
              cookieQuery('iframe' + '[data-cookiescript="accepted"]').not(':has([src])').each(function () {
                var ifrm = this;

                ifrm = (ifrm.contentWindow) ? ifrm.contentWindow : (ifrm.contentDocument.document) ? ifrm.contentDocument.document : ifrm.contentDocument;

                ifrm.document.open();
                ifrm.document.write("<p>" + cookieQuery(this).attr("name") + "</p>");
                ifrm.document.close();
              });
            }


	 function cookieScriptLoadValueCategories() {
            	var readCategories = cookieScriptReadVar("categories");
            	var action = cookieScriptReadVar("action");
            	if(readCategories) {
            		var categories = JSON.parse(readCategories);
            		cookieQuery("#cookiescript_injected input[data-cookiescript='checkbox-input']").each(function() {
            			if(categories.includes(cookieQuery(this).val()) || cookieQuery(this).val() === "strict") {
            			    cookieQuery(this).prop("checked", true);
            			} else {
            				cookieQuery(this).prop("checked", false);
            			}
            		});
            	}
            }


            function cookieScriptAcceptFunction() {
			  cookieQuery("#cookiescript_injected", cookieScriptWindow).fadeOut(200);
				cookieScriptAddVar("action", "accept");
              cookieScriptAllowJS();
              cookieQuery("#csconsentcheckbox").prop("checked", true);
              if (typeof cookieScriptShowBadge === "undefined") cookieScriptShowBadge=true;
              if(!cookieScriptShowBadge) return false;
							cookieScriptToggleAcceptedFunction();
              cookieScriptShowBadgeFunction();
            }

            function cookieScriptRejectFunction() {
			  cookieScriptAddVar("action", "reject");
              cookieScriptClearAllCookies({ isForce: true });
              cookieQuery("#cookiescript_injected", cookieScriptWindow).fadeOut(200);
              cookieQuery("#csconsentcheckbox").prop("checked", false);
              if (typeof cookieScriptShowBadge === "undefined") cookieScriptShowBadge=true;
              if(!cookieScriptShowBadge) return false;
              cookieScriptShowBadgeFunction();
            }

            function cookieScriptCloseFunction() {
				cookieQuery("#cookiescript_injected", cookieScriptWindow).fadeOut(200);
				if (typeof cookieScriptShowBadge === "undefined") cookieScriptShowBadge=true;
				if(!cookieScriptShowBadge) return false;
				cookieScriptShowBadgeFunction();
            }

            function cookieScriptAcceptAllFunction() {
				cookieQuery("#cookiescript_injected input[data-cookiescript='checkbox-input']").each(function() {
            			 cookieQuery(this).prop("checked", true);
            		});
            	setTimeout(cookieScriptRejectFunction, 50);
            }

            function cookieScriptRejectAllFunction() {
				cookieQuery("#cookiescript_injected input[data-cookiescript='checkbox-input']").each(function() {
            			if(cookieQuery(this).val() === "strict") {
            			    cookieQuery(this).prop("checked", true);
            			} else {
            				cookieQuery(this).prop("checked", false);
            			}
            		});
            	setTimeout(cookieScriptRejectFunction, 50);
            }

            function cookieScriptAddVar(name,value){
            	var cookieConsentName="CookieScriptConsent";
            	try {
            		var jsonCookie=JSON.parse(cookieScriptReadCookie(cookieConsentName));
            	} catch(e) {
					console.log(e);
					return false;
				}

				if(jsonCookie==null)
				{
					var jsonCookie={};
					jsonCookie[name]=value
				}
				else //todo Add is object
				{
					jsonCookie[name]=value;
				}
				try{
					var newCookieVal=JSON.stringify(jsonCookie);
				} catch(e){
					console.log(e);
					return false;
				}
				cookieScriptCreateCookie(cookieConsentName, newCookieVal, 30);
            }

            function cookieScriptReadVar(name){
            	var cookieConsentName="CookieScriptConsent";
            	try {
            		var jsonCookie=JSON.parse(cookieScriptReadCookie(cookieConsentName));
            	} catch(e) {
					console.log(e);
					return null;
				}

				if(jsonCookie==null)
				{
					return null;
				}
				else //todo Add is object
				{
					return jsonCookie[name];
				}
            }
            function cookieScriptShowBadgeFunction() {

              if (cookieQuery("#cookiescript_badge").length) {
                cookieQuery("#cookiescript_badge", cookieScriptWindow).delay(200).fadeIn(200);
              }
              else {
                cookieQuery("body", cookieScriptWindow).append('<div id="cookiescript_badge"><div id="cookiescript_badgeimage"><svg id="cookiescript_badgesvg" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 478.703 478.703"><defs></defs><title>Cookie-Script logo</title><g id="cs_layer_2" data-name="cs_layer_2"><g id="cs_layer_1" data-name="cs_layer_1"><path class="cookiescriptlogo" d="M454.2,189.101l-33.6-5.7c-3.5-11.3-8-22.2-13.5-32.6l19.8-27.7c8.4-11.8,7.1-27.9-3.2-38.1l-29.8-29.8c-5.6-5.6-13-8.7-20.9-8.7c-6.2,0-12.1,1.9-17.1,5.5l-27.8,19.8c-10.8-5.7-22.1-10.4-33.8-13.9l-5.6-33.2c-2.4-14.3-14.7-24.7-29.2-24.7h-42.1c-14.5,0-26.8,10.4-29.2,24.7l-5.8,34c-11.2,3.5-22.1,8.1-32.5,13.7l-27.5-19.8c-5-3.6-11-5.5-17.2-5.5c-7.9,0-15.4,3.1-20.9,8.7l-29.9,29.8c-10.2,10.2-11.6,26.3-3.2,38.1l20,28.1c-5.5,10.5-9.9,21.4-13.3,32.7l-33.2,5.6c-14.3,2.4-24.7,14.7-24.7,29.2v42.1c0,14.5,10.4,26.8,24.7,29.2l34,5.8c3.5,11.2,8.1,22.1,13.7,32.5l-19.7,27.4c-8.4,11.8-7.1,27.9,3.2,38.1l29.8,29.8c5.6,5.6,13,8.7,20.9,8.7c6.2,0,12.1-1.9,17.1-5.5l28.1-20c10.1,5.3,20.7,9.6,31.6,13l5.6,33.6c2.4,14.3,14.7,24.7,29.2,24.7h42.2c14.5,0,26.8-10.4,29.2-24.7l5.7-33.6c11.3-3.5,22.2-8,32.6-13.5l27.7,19.8c5,3.6,11,5.5,17.2,5.5l0,0c7.9,0,15.3-3.1,20.9-8.7l29.8-29.8c10.2-10.2,11.6-26.3,3.2-38.1l-19.8-27.8c5.5-10.5,10.1-21.4,13.5-32.6l33.6-5.6c14.3-2.4,24.7-14.7,24.7-29.2v-42.1C478.9,203.801,468.5,191.501,454.2,189.101z M451.9,260.401c0,1.3-0.9,2.4-2.2,2.6l-42,7c-5.3,0.9-9.5,4.8-10.8,9.9c-3.8,14.7-9.6,28.8-17.4,41.9c-2.7,4.6-2.5,10.3,0.6,14.7l24.7,34.8c0.7,1,0.6,2.5-0.3,3.4l-29.8,29.8c-0.7,0.7-1.4,0.8-1.9,0.8c-0.6,0-1.1-0.2-1.5-0.5l-34.7-24.7c-4.3-3.1-10.1-3.3-14.7-0.6c-13.1,7.8-27.2,13.6-41.9,17.4c-5.2,1.3-9.1,5.6-9.9,10.8l-7.1,42c-0.2,1.3-1.3,2.2-2.6,2.2h-42.1c-1.3,0-2.4-0.9-2.6-2.2l-7-42c-0.9-5.3-4.8-9.5-9.9-10.8c-14.3-3.7-28.1-9.4-41-16.8c-2.1-1.2-4.5-1.8-6.8-1.8c-2.7,0-5.5,0.8-7.8,2.5l-35,24.9c-0.5,0.3-1,0.5-1.5,0.5c-0.4,0-1.2-0.1-1.9-0.8l-29.8-29.8c-0.9-0.9-1-2.3-0.3-3.4l24.6-34.5c3.1-4.4,3.3-10.2,0.6-14.8c-7.8-13-13.8-27.1-17.6-41.8c-1.4-5.1-5.6-9-10.8-9.9l-42.3-7.2c-1.3-0.2-2.2-1.3-2.2-2.6v-42.1c0-1.3,0.9-2.4,2.2-2.6l41.7-7c5.3-0.9,9.6-4.8,10.9-10c3.7-14.7,9.4-28.9,17.1-42c2.7-4.6,2.4-10.3-0.7-14.6l-24.9-35c-0.7-1-0.6-2.5,0.3-3.4l29.8-29.8c0.7-0.7,1.4-0.8,1.9-0.8c0.6,0,1.1,0.2,1.5,0.5l34.5,24.6c4.4,3.1,10.2,3.3,14.8,0.6c13-7.8,27.1-13.8,41.8-17.6c5.1-1.4,9-5.6,9.9-10.8l7.2-42.3c0.2-1.3,1.3-2.2,2.6-2.2h42.1c1.3,0,2.4,0.9,2.6,2.2l7,41.7c0.9,5.3,4.8,9.6,10,10.9c15.1,3.8,29.5,9.7,42.9,17.6c4.6,2.7,10.3,2.5,14.7-0.6l34.5-24.8c0.5-0.3,1-0.5,1.5-0.5c0.4,0,1.2,0.1,1.9,0.8l29.8,29.8c0.9,0.9,1,2.3,0.3,3.4l-24.7,34.7c-3.1,4.3-3.3,10.1-0.6,14.7c7.8,13.1,13.6,27.2,17.4,41.9c1.3,5.2,5.6,9.1,10.8,9.9l42,7.1c1.3,0.2,2.2,1.3,2.2,2.6v42.1H451.9z"/><path class="cookiescriptlogo" d="M239.4,136.001c-57,0-103.3,46.3-103.3,103.3s46.3,103.3,103.3,103.3s103.3-46.3,103.3-103.3S296.4,136.001,239.4,136.001z M239.4,315.601c-42.1,0-76.3-34.2-76.3-76.3s34.2-76.3,76.3-76.3s76.3,34.2,76.3,76.3S281.5,315.601,239.4,315.601z"/></g></g></svg></div><div id="cookiescript_badgetext">'+cookieScriptBadgeText+'</div></div>');
                cookieQuery("#cookiescript_badge", cookieScriptWindow).delay(200).fadeIn(200);
                cookieQuery("#cookiescript_badge").click(cookieScriptShowConsent);
              };
            }
						function cookieScriptToggleAcceptedFunction () {
							if(cookieScriptToggle) {
								forEach(cookieScriptToggle, function(e) {
			            e.classList.remove('smc-cookies--rejected');
									e.classList.add('smc-cookies--accepted');
				        });
							}
							document.body.classList.remove('smc-cookies--rejected');
							document.body.classList.add('smc-cookies--accepted');
						}
						function cookieScriptToggleRejectedFunction () {
							if(cookieScriptToggle) {
								forEach(cookieScriptToggle, function(e) {
									e.classList.remove('smc-cookies--accepted');
									e.classList.add('smc-cookies--rejected');
								});
							}
							document.body.classList.remove('smc-cookies--accepted');
							document.body.classList.add('smc-cookies--rejected');
							
						}
            function cookieScriptShowConsent() {
              if (cookieQuery("#cookiescript_badge").length) {
                cookieQuery("#cookiescript_badge", cookieScriptWindow).fadeOut(200);
              }

              if (cookieQuery("#cookiescript_injected").length) {
                cookieQuery("#cookiescript_injected", cookieScriptWindow).delay(200).fadeIn(200);
              }
              else {
              	setTimeout(cookieScriptAddBox,150);
              }
            }


            function cookieScriptEnableCheckbox(){

				if(cookieScriptReadVar("action") == "accept")
				{
					cookieQuery("#csconsentcheckbox").prop("checked", true);
				}
				cookieQuery("#csconsentcheckbox").change(function() {
					if(this.checked) {
						cookieScriptAcceptFunction();
					}
					else{
						cookieScriptRejectFunction();
					}
				});
				cookieQuery("#csconsentlink").click(function() {
					cookieScriptShowConsent();
				});


            }
            cookieScriptEnableCheckbox();

	function cookieScriptClearAllCookies(params){
	    var isForce = params && params.isForce
	    var isLoad = params && params.isLoad || false

		var cookies = csCookies.get();
		if(cookieScriptDebug){
		console.log(cookies)
		}
		for(var cookie in cookies) {
			if(cookie=='CookieScriptConsent') { continue; }

			if(!csCookies.remove(cookie))
			{
				var cookiePossibleHosts=[window.location.host, '.'+window.location.host];
				//now removing subdomains
				var regexParse = new RegExp('[a-z\-0-9]{2,63}\.[a-z\.]{2,6}$');
				var urlParts = regexParse.exec(window.location.host);
				var cookieSubdomain=window.location.host.replace(urlParts[0],'').slice(0, -1);
				if(cookieSubdomain != '') cookiePossibleHosts.push(window.location.host.substr(cookieSubdomain.length));
				for(var cookiePossibleHost in cookiePossibleHosts)
				{
					if(csCookies.remove(cookie, { path: '/',domain: cookiePossibleHosts[cookiePossibleHost] }) && cookieScriptDebug)
					console.log('deleting cookie:'+cookie+'| domain:'+cookiePossibleHosts[cookiePossibleHost]);
				}
			}
		}
	}


	if(cookieScriptReadVar("action") != "accept" && !window.location.hash.includes("b01d052f340553efb58be19c7d3bc681")) {
		setTimeout(function() {  cookieScriptClearAllCookies({ isLoad: true }) }, 500);
		}
if(window.location.hash.includes("b01d052f340553efb58be19c7d3bc681")){
	cookieScriptAllowJS();
}
		function cookieScriptAllowJS(category){
			var cookieScriptSpecialAttribute = category
			? '[data-cookiescript="accepted"][data-cookiecategory="'+ category +'"]'
			: '[data-cookiescript="accepted"]';

			cookieQuery('img'+ cookieScriptSpecialAttribute).each(function () {
				cookieQuery(this).attr('src', cookieQuery(this).attr("data-src"));
       		});
			cookieQuery('script'+'[type="text/plain"]'+ cookieScriptSpecialAttribute).each(function () {
				if (cookieQuery(this).attr('src')) {
					cookieQuery(this).after('<script type="text/javascript" src="' + cookieQuery(this).attr("src") + '"><\/script>')
				} else {
					cookieQuery(this).after('<script type="text/javascript">' + cookieQuery(this).html() + '<\/script>')
				}
				cookieQuery(this).empty()
       		});
			cookieQuery('iframe'+ cookieScriptSpecialAttribute).each(function () {
				cookieQuery(this).attr('src', cookieQuery(this).attr("data-src"));
       		});
			cookieQuery('embed'+ cookieScriptSpecialAttribute).each(function () {
				cookieQuery(this).replaceWith(cookieQuery(this).attr('src',cookieQuery(this).attr("data-src"))[0].outerHTML);
       		});
			cookieQuery('object'+ cookieScriptSpecialAttribute).each(function () {
				cookieQuery(this).replaceWith(cookieQuery(this).attr('data',cookieQuery(this).attr("data-data"))[0].outerHTML);
       		});
			cookieQuery('link'+ cookieScriptSpecialAttribute).each(function () {
				cookieQuery(this).attr('href', cookieQuery(this).attr("data-href"));
			});
		}

		function cookieScriptTrack(action, categories){return false;}        };


window.jQuery && jQuery.fn && /^(1\.[8-9]|2\.[0-9]|1\.1[0-2]|3\.[0-9])/.test(jQuery.fn.jquery) ? (cookieScriptDebug && window.console && console.log("Using existing jQuery version " + jQuery.fn.jquery), cookieQuery = window.jQuery, InjectCookieScript()) : (cookieScriptDebug && window.console && console.log("Loading jQuery 1.8.1 from ajax.googleapis.com"), cookieScriptLoadJavaScript("/assets/built/jquery-1.8.1.min.js", function () {cookieQuery = jQuery.noConflict(!0), InjectCookieScript();}));
